import Banner from "../assets/Bannerlogo.png";
import logo from "../assets/logo.png";

import React, { useEffect } from 'react';


const useMousePosition = () => {
  const [mousePosition, setMousePosition] = React.useState({x:0, y:0})
  useEffect(()=>{
    const updateMousePosition = event => {
      setMousePosition({x: event.clientX, y: event.clientY})
      
    }    
   window.addEventListener('mousemove',updateMousePosition);
    return () => window.removeEventListener('mousemove', updateMousePosition)
  },[])
  
    return mousePosition   
    
}



const Header = () => {
  
  let bannerimg = document.querySelector('#banner_head');
  const {x,y} = useMousePosition();
  console.log(x,y);
  if(x>0 && x<550  ){
    bannerimg.style.transform = 'translateX(10rem)';
    bannerimg.style.transition = '1s';
  }
 else if(x>765&& x<1000){
  bannerimg.style.transform = 'translateX(-10rem)';
  bannerimg.style.transition = '1s';
 }
//  else{
//   bannerimg.style.transform = 'translateX(0rem)';
//   bannerimg.style.transition = '1s';
//  }
  
  
  return (
    
    <div className="Header" >
      <img src={Banner} alt="" id="banner_head" />
      <h1>
        {" "}
        One <span> Index for</span> Every <span> Asset</span>{" "}
      </h1>
      <div className="headerBtn">
        
        <button className="buy">
          BUY <img src={logo} alt="" /> MRI
        </button>
        
        <button className="readMore">READ MORE ABOUT INDEX</button>
      </div>
      <div className="Header-content">
        <p>
          M & Rrotocol is a Decentralized Finance (DEFI) Protocol functioning as
          a fully decentralized, on-chain, treasury-backed, and redeemable
          crypto asset index. Meaning, the Index Protocol is a DEFI protocol
          creating fully transparent, treasury-backed, and redeemable
          crypto-asset pools. Making cryptocurrency investments safer, more
          secure, and more flexible than ever before.
        </p>
      </div>
    </div>
  );
};

export default Header;
